// TD Before & After review slides.
if (!customElements.get('td-before-after-proof')) {
  class TDBeforeAfterProof extends HTMLElement {
    static SELECTORS = {
      contentSlider: '[data-td-before-after-content-slider]',
      mediaSlide: '[data-td-before-after-media-slide]',
      contentSlide: '[data-td-before-after-content-slide]',
      contentViewport: '[data-td-before-after-content-slider] [data-td-embla-viewport]',
    };

    constructor() {
      super();
      this.contentEmblaApi = null;
      this.handleEmblaInit = this.handleEmblaInit.bind(this);
      this.handleContentSelect = this.handleContentSelect.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
      this.handleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      this.contentSliderElement = this.querySelector(TDBeforeAfterProof.SELECTORS.contentSlider);
      this.mediaSlideElements = Array.from(this.querySelectorAll(TDBeforeAfterProof.SELECTORS.mediaSlide));
      this.contentSlideElements = Array.from(this.querySelectorAll(TDBeforeAfterProof.SELECTORS.contentSlide));
      this.contentViewportElement = this.querySelector(TDBeforeAfterProof.SELECTORS.contentViewport);

      if (!(this.contentSliderElement instanceof HTMLElement)) {
        return;
      }

      this.contentSliderElement.addEventListener('embla:init', this.handleEmblaInit);

      if (this.contentSliderElement.emblaApi) {
        this.attachContentApi(this.contentSliderElement.emblaApi);
      }

      document.addEventListener('shopify:block:select', this.handleBlockSelect);
      window.addEventListener('resize', this.handleResize, { passive: true });

      if (typeof ResizeObserver === 'function' && this.contentViewportElement instanceof HTMLElement) {
        this.resizeObserver = new ResizeObserver(() => {
          this.updateSliderState();
        });
        this.resizeObserver.observe(this.contentViewportElement);
      }

      this.updateSliderState();
    }

    disconnectedCallback() {
      this.contentSliderElement?.removeEventListener('embla:init', this.handleEmblaInit);
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      window.removeEventListener('resize', this.handleResize);
      this.resizeObserver?.disconnect();
      this.resizeObserver = null;
      this.detachContentApi();
    }

    handleEmblaInit(event) {
      const emblaApi = event?.detail?.api || this.contentSliderElement?.emblaApi;
      if (emblaApi) {
        this.attachContentApi(emblaApi);
      }
    }

    attachContentApi(emblaApi) {
      this.detachContentApi();
      this.contentEmblaApi = emblaApi;
      this.contentEmblaApi.on('select', this.handleContentSelect);
      this.contentEmblaApi.on('reInit', this.handleContentSelect);
      this.handleContentSelect();
    }

    detachContentApi() {
      this.contentEmblaApi?.off('select', this.handleContentSelect);
      this.contentEmblaApi?.off('reInit', this.handleContentSelect);
      this.contentEmblaApi = null;
    }

    handleContentSelect() {
      if (!this.contentEmblaApi) {
        return;
      }

      this.setActiveMedia(this.contentEmblaApi.selectedScrollSnap());
      this.updateSliderState();
    }

    setActiveMedia(selectedIndex) {
      this.mediaSlideElements.forEach((slide, index) => {
        slide.classList.toggle('td-before-after__media-slide--active', index === selectedIndex);
      });
    }

    handleBlockSelect(event) {
      const blockId = event.detail?.blockId;
      const slide = this.getSlideByBlockId(blockId);
      if (!(slide instanceof HTMLElement)) {
        return;
      }

      const slideIndex = this.contentSlideElements.indexOf(slide);
      if (slideIndex >= 0) {
        this.contentEmblaApi?.scrollTo(slideIndex, true);
        this.setActiveMedia(slideIndex);
      }
    }

    getSlideByBlockId(blockId) {
      if (!blockId) {
        return null;
      }

      const escapedBlockId = typeof CSS !== 'undefined' && typeof CSS.escape === 'function' ? CSS.escape(blockId) : blockId;
      return this.querySelector(`[data-td-before-after-content-slide][data-td-block-id="${escapedBlockId}"]`);
    }

    handleResize() {
      this.contentEmblaApi?.reInit();
      this.updateSliderState();
    }

    updateSliderState() {
      if (!(this.contentViewportElement instanceof HTMLElement)) {
        return;
      }

      const hasOverflow = this.contentViewportElement.scrollWidth - this.contentViewportElement.clientWidth > 1;
      this.dataset.tdSliderActive = hasOverflow ? 'true' : 'false';
    }
  }

  customElements.define('td-before-after-proof', TDBeforeAfterProof);
}
